export default "__VITE_ASSET__COVJGyIP__"